import styled from "styled-components";

import {
  DATA_E2E_KEY,
  DRAWER_FOOTER_HEIGHT,
  type IStyledAttributes,
} from "@ryde/shared";
import { greyMui, MOBILE_BREAKPOINT } from "@ryde/theme";

export const CrudEditFormFooterStyled = styled.footer.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "crud-edit-form-footer-styled",
})`
  border-top: 1px solid ${greyMui._300};
  display: flex;
  align-items: center;
  padding-inline: 24px;
  justify-content: flex-end;
  height: ${DRAWER_FOOTER_HEIGHT}px;
  gap: 12px;

  transition:
    filter 0.55s ease-out,
    backdrop-filter 0.55s ease-out;
  &.inner-item-editing {
    filter: blur(2px) grayscale(100%);
    backdrop-filter: blur(3px);
    pointer-events: none;
  }

  .cancel_button {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-inline-start: auto;
  }

  /* On a phone the buttons don't fit one row: wrap them, or flex-end pushes the first ones off the drawer's start edge. */
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex-wrap: wrap;
    justify-content: flex-start;
    height: auto;
    min-height: ${DRAWER_FOOTER_HEIGHT}px;
    padding-block: 12px;
    padding-inline: 10px;

    .cancel_button {
      flex-wrap: wrap;
      justify-content: flex-end;
    }

    /* The theme's lineHeight: 0 stacks a wrapped label's lines on top of each other. */
    .MuiButton-root {
      line-height: normal;
    }
  }
`;
